import React, { useContext, useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import utils from '@/common/utils';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import defaultData from '../../../constants/data';
import ActivityData from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/activity-data';

export default function FlowData({ data = defaultData }) {
  const history = useHistory();

  const { isManage } = useContext(ContextProviderMenus);

  useLayoutEffect(() => {
    let queryObj = utils.parseQuery(window.location.search);
    queryObj.hideTab = 1;
    if (isManage != null) {
      // id: 会场活动ID
      // userType: 2 管理员
      // activityState:  0 无效 1 有效 2 全部（本期只有2）
      queryObj.activityStatus = 2;
      queryObj.userType = isManage ? 2 : 1;
      queryObj.activityId = queryObj.id = queryObj.id || queryObj.activityId;
    }

    history.replace(window.location.pathname + `?${utils.formatQueryObj(queryObj)}`);
    // eslint-disable-next-line
  }, [isManage]);

  // 如果有查询参数将它push到query后面

  // 管理者 http://test.mc.jd.com/manage/activityData
  // 参与者 http://test.mc.jd.com/manage/activityData
  return <ActivityData data={data} destory />;
}
